import { render, staticRenderFns } from "./brand_list.vue?vue&type=template&id=5cc397fa&scoped=true"
import script from "./brand_list.vue?vue&type=script&lang=js"
export * from "./brand_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc397fa",
  null
  
)

export default component.exports